export enum SeriesZIndexMap {
    BACKGROUND,
    ANY_CONTENT,
}

export enum SeriesContentZIndexMap {
    FOREGROUND,
    HIGHLIGHT,
    LABEL,
}
